/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { PriceAmounts } from '@sm360/widget-commons-general';

import { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

const FilterRange = (props) => {
    function handleChange(values) {
        const [selectedMin, selectedMax] = values;
        props.handleSelectedValue(selectedMin, selectedMax);
    }

    function updateQuery(values) {
        const [selectedMin, selectedMax] = values;
        props.updateQuery(selectedMin, selectedMax);
    }

    return (
        <div className="listing-used-filters-bloc listing-used-filters-price sr-slide">
            <div className="listing-used-filters-title sr-text is-bold">{props.title}</div>
            <div className="slider-labels clearfix">
                <div className="slider-label-min">
                    {props.isPrice ? <PriceAmounts price={props.labelMin} /> : props.labelMin}
                </div>
                <div className="slider-label-max">
                    {props.isPrice ? <PriceAmounts price={props.labelMax} /> : props.labelMax}
                </div>
            </div>
            <Range
                value={[props.defaultMin, props.defaultMax]}
                allowCross={false}
                defaultValue={[props.defaultMin, props.defaultMax]}
                onAfterChange={updateQuery}
                min={props.extremeMin}
                max={props.extremeMax}
                onChange={handleChange}
                step={props.step}
            />
        </div>
    );
};

FilterRange.defaultProps = {
    isPrice: false,
};

FilterRange.propTypes = {
    title: PropTypes.string.isRequired,
    extremeMin: PropTypes.number.isRequired,
    extremeMax: PropTypes.number.isRequired,
    defaultMin: PropTypes.number.isRequired,
    defaultMax: PropTypes.number.isRequired,
    step: PropTypes.number.isRequired,
    labelMin: PropTypes.string.isRequired,
    labelMax: PropTypes.string.isRequired,
    updateQuery: PropTypes.func.isRequired,
    handleSelectedValue: PropTypes.func.isRequired,
    isPrice: PropTypes.bool,
};

FilterRange.displayName = 'FilterRange';

export default FilterRange;
